/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Acted Core API
 * Core backend API.
 * OpenAPI spec version: 1.0.0
 */
import {
  HttpClient
} from '@angular/common/http';
import type {
  HttpContext,
  HttpEvent,
  HttpParams
} from '@angular/common/http';

import type {
  HttpHeaders,
  HttpResponse as AngularHttpResponse
} from '@angular/common/http';

import {
  Injectable,
  inject
} from '@angular/core';

import type {
  Observable
} from 'rxjs';

import type {
  BudgetLine,
  BudgetLinesListParams,
  PaginatedBudgetLineList
} from '../model';

import {
  environment
} from 'environments/environment';



import { filterParams, HttpClientBodyOptions, HttpClientEventOptions, HttpClientObserveOptions, HttpClientResponseOptions } from '../httpClientOptions';

@Injectable({ providedIn: 'root' })
export class BudgetLinesService {
  private readonly http = inject(HttpClient);
 list<TData = PaginatedBudgetLineList>(params?: BudgetLinesListParams, options?: HttpClientBodyOptions): Observable<TData>;
 list<TData = PaginatedBudgetLineList>(params?: BudgetLinesListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 list<TData = PaginatedBudgetLineList>(params?: BudgetLinesListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  list<TData = PaginatedBudgetLineList>(
    params?: BudgetLinesListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `${environment.apiRoot}/api/budget-lines/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `${environment.apiRoot}/api/budget-lines/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `${environment.apiRoot}/api/budget-lines/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
 titleOnes<TData = BudgetLine>( options?: HttpClientBodyOptions): Observable<TData>;
 titleOnes<TData = BudgetLine>( options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 titleOnes<TData = BudgetLine>( options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  titleOnes<TData = BudgetLine>(
     options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `${environment.apiRoot}/api/budget-lines/title-ones/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `${environment.apiRoot}/api/budget-lines/title-ones/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `${environment.apiRoot}/api/budget-lines/title-ones/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
};

